<template>
  <div class="expert-team-detail">
    <!-- 导航栏 -->
    <header class="navbar">
      <div class="container" style="max-width: 100%;">
        <div class="logo">
          <img src="/hhwl.png" alt="北京和合网链科技有限公司" />
          <span>北京和合网链科技有限公司</span>
        </div>
        <nav class="nav-links">
          <router-link to="/" class="nav-link">首页</router-link>
          <router-link to="/health-detection" class="nav-link">健康检测</router-link>
          <router-link to="/health-management" class="nav-link">健康管理</router-link>
          <router-link to="/conditioning-service" class="nav-link">调理服务</router-link>
          <router-link to="/expert-team" class="nav-link" style="color: #3498db;">专家团队</router-link>
          <router-link to="/news" class="nav-link">行业资讯</router-link>
          <router-link to="/cases" class="nav-link">成功案例</router-link>
          <router-link to="/appointment-service" class="nav-link">预约服务</router-link>
        </nav>
        <div class="user-actions" style="width: 414.34px;"></div>
      </div>
    </header>

    <!-- 页面标题 -->
    <section class="page-header">
      <div class="container">
        <h1>专家团队</h1>
        <p>汇聚顶尖健康专家，为您提供专业健康服务</p>
      </div>
    </section>

    <!-- 团队概述 -->
    <section class="team-overview">
      <div class="container">
        <div class="overview-content">
          <div class="overview-text">
            <h2>专业团队，值得信赖</h2>
            <p>我们的专家团队由来自医学、生物学、营养学、心理学等多个领域的专业人士组成。每位专家都拥有丰富的临床经验和深厚的学术背景，致力于为客户提供最专业、最贴心的健康服务。</p>
            <p>团队成员定期参加国内外学术交流，不断更新知识体系，确保为客户提供最前沿的健康管理方案。我们相信，专业的团队是优质服务的基石。</p>
          </div>
          <div class="overview-stats">
            <div class="stat-item">
              <div class="stat-number">20+</div>
              <div class="stat-label">资深专家</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">15年+</div>
              <div class="stat-label">平均从业经验</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">10000+</div>
              <div class="stat-label">服务客户</div>
            </div>
            <div class="stat-item">
              <div class="stat-number">98%</div>
              <div class="stat-label">客户满意度</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心专家 -->
    <section class="core-experts">
      <div class="container">
        <h2 class="section-title">核心专家</h2>
        <div class="experts-grid">
          <div class="expert-card" v-for="expert in coreExperts" :key="expert.id">
            <div class="expert-image">
              <div class="expert-avatar">{{ expert.avatar }}</div>
            </div>
            <div class="expert-info">
              <h3>{{ expert.name }}</h3>
              <p class="expert-title">{{ expert.title }}</p>
              <p class="expert-specialty">{{ expert.specialty }}</p>
              <div class="expert-bio">
                <p>{{ expert.bio }}</p>
              </div>
              <div class="expert-achievements">
                <h4>主要成就</h4>
                <ul>
                  <li v-for="achievement in expert.achievements" :key="achievement">
                    {{ achievement }}
                  </li>
                </ul>
              </div>
              <button @click="viewExpertDetail(expert)" class="btn-detail">查看详情</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 专业团队 -->
    <section class="professional-team">
      <div class="container">
        <h2 class="section-title">专业团队</h2>
        <div class="team-categories">
          <div class="category-tabs">
            <button 
              v-for="category in teamCategories" 
              :key="category.id"
              :class="['tab-btn', { active: activeCategory === category.id }]"
              @click="activeCategory = category.id"
            >
              {{ category.name }}
            </button>
          </div>
          <div class="team-members">
            <div 
              v-for="member in filteredTeamMembers" 
              :key="member.id"
              class="team-member"
            >
              <div class="member-avatar">{{ member.avatar }}</div>
              <h4>{{ member.name }}</h4>
              <p class="member-title">{{ member.title }}</p>
              <p class="member-specialty">{{ member.specialty }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 团队优势 -->
    <section class="team-advantages">
      <div class="container">
        <h2 class="section-title">团队优势</h2>
        <div class="advantages-grid">
          <div class="advantage-card">
            <div class="advantage-icon">🎓</div>
            <h3>学术背景雄厚</h3>
            <p>团队成员均来自国内外知名院校，拥有硕士、博士学位，学术功底扎实</p>
          </div>
          <div class="advantage-card">
            <div class="advantage-icon">🏥</div>
            <h3>临床经验丰富</h3>
            <p>平均15年以上临床经验，处理过各种复杂健康案例，实践经验丰富</p>
          </div>
          <div class="advantage-card">
            <div class="advantage-icon">🔬</div>
            <h3>专业技术领先</h3>
            <p>掌握最新的健康检测技术和治疗方法，始终站在行业技术前沿</p>
          </div>
          <div class="advantage-card">
            <div class="advantage-icon">💝</div>
            <h3>服务理念先进</h3>
            <p>以客户为中心，提供个性化、全方位的健康管理服务，注重服务体验</p>
          </div>
          <div class="advantage-card">
            <div class="advantage-icon">🤝</div>
            <h3>团队协作紧密</h3>
            <p>多学科专家团队协作，为客户提供综合性的健康解决方案</p>
          </div>
          <div class="advantage-card">
            <div class="advantage-icon">📚</div>
            <h3>持续学习成长</h3>
            <p>定期参加专业培训和学术交流，不断提升专业水平和服务能力</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务流程 -->
    <section class="service-process">
      <div class="container">
        <h2 class="section-title">专家服务流程</h2>
        <div class="process-flow">
          <div class="process-step">
            <div class="step-icon">📋</div>
            <h3>需求评估</h3>
            <p>专家团队详细了解客户健康状况和需求</p>
          </div>
          <div class="process-arrow">→</div>
          <div class="process-step">
            <div class="step-icon">🔍</div>
            <h3>精准检测</h3>
            <p>运用先进设备进行全面健康检测</p>
          </div>
          <div class="process-arrow">→</div>
          <div class="process-step">
            <div class="step-icon">📊</div>
            <h3>数据分析</h3>
            <p>专家团队综合分析检测数据</p>
          </div>
          <div class="process-arrow">→</div>
          <div class="process-step">
            <div class="step-icon">💡</div>
            <h3>方案制定</h3>
            <p>制定个性化健康管理方案</p>
          </div>
          <div class="process-arrow">→</div>
          <div class="process-step">
            <div class="step-icon">🎯</div>
            <h3>跟踪服务</h3>
            <p>持续跟踪健康改善情况</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户评价 -->
    <section class="testimonials">
      <div class="container">
        <h2 class="section-title">客户评价</h2>
        <div class="testimonials-grid">
          <div class="testimonial-card" v-for="testimonial in testimonials" :key="testimonial.id">
            <div class="testimonial-content">
              <p>"{{ testimonial.content }}"</p>
            </div>
            <div class="testimonial-author">
              <div class="author-avatar">{{ testimonial.avatar }}</div>
              <div class="author-info">
                <h4>{{ testimonial.name }}</h4>
                <p>{{ testimonial.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 预约咨询 -->
    <section class="consultation-booking">
      <div class="container">
        <div class="booking-content">
          <div class="booking-text">
            <h2>预约专家咨询</h2>
            <p>与我们的健康专家进行一对一深入交流，获得专业的健康指导和个性化的健康管理方案。</p>
            <div class="booking-benefits">
              <div class="benefit">✓ 资深专家一对一服务</div>
              <div class="benefit">✓ 个性化健康评估</div>
              <div class="benefit">✓ 专业健康管理方案</div>
              <div class="benefit">✓ 后续跟踪指导</div>
            </div>
          </div>
          <div class="booking-form">
            <h3>快速预约</h3>
            <form @submit.prevent="submitBooking">
              <div class="form-group">
                <label>姓名</label>
                <input type="text" v-model="bookingForm.name" placeholder="请输入您的姓名" required>
              </div>
              <div class="form-group">
                <label>电话</label>
                <input type="tel" v-model="bookingForm.phone" placeholder="请输入您的电话" required>
              </div>
              <div class="form-group">
                <label>咨询类型</label>
                <select v-model="bookingForm.type" required>
                  <option value="">请选择咨询类型</option>
                  <option value="health">健康检测</option>
                  <option value="management">健康管理</option>
                  <option value="consultation">专家咨询</option>
                  <option value="conditioning">健康调理</option>
                </select>
              </div>
              <div class="form-group">
                <label>预约时间</label>
                <input type="datetime-local" v-model="bookingForm.datetime" required>
              </div>
              <button type="submit" class="btn-submit">提交预约</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- 页面底部 -->
    
    <footer class="footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <h3>北京和合网链科技有限公司</h3>
            <p>专注健康科技，守护您的健康</p>
            <div class="contact-info">
              <p><i class="el-icon-location"></i> 地址：北京市丰台区南三环西路91号院1号楼14层1单元1706</p>
              <p><i class="el-icon-phone"></i> 电话：15383753755</p>
              <p><i class="el-icon-message"></i> 邮箱：james@tssen.com</p>
            </div>
          </div>
          <div class="footer-links-group">
            <div class="footer-links">
              <h4>快速导航</h4>
              <a href="#home">首页</a>
              <a href="#about">关于我们</a>
              <a href="#services">服务介绍</a>
              <a href="#contact">联系我们</a>
            </div>
            <div class="footer-services">
              <h4>服务项目</h4>
              <a href="#">健康检测</a>
              <a href="#">专家咨询</a>
              <a href="#">健康管理</a>
              <a href="#">调理服务</a>
            </div>
            <div class="footer-social">
              <h4>关注我们</h4>
              <div class="social-icons">
                <a href="#" class="social-icon"><i class="el-icon-chat-line-square"></i> 微信公众号</a>
                <a href="#" class="social-icon"><i class="el-icon-message-solid"></i> 官方客服</a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="copyright">
            <p style="font-size: 12px;">© 2025 北京和合网链科技发展有限公司 版权所有 | 冀ICP备14010297号 | 冀ICP备14010297号-2 | 域名：tssen.com</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'ExpertTeamDetail',
  data() {
    return {
      activeCategory: 'medical',
      bookingForm: {
        name: '',
        phone: '',
        type: '',
        datetime: ''
      },
      coreExperts: [
        {
          id: 1,
          name: '张明华',
          avatar: '👨‍⚕️',
          title: '首席健康专家',
          specialty: '量子健康检测、慢性病管理',
          bio: '从事健康管理工作20余年，在量子健康检测技术领域有深厚造诣。曾主持多项国家级健康科研项目，发表学术论文50余篇。擅长慢性病早期筛查和个性化健康管理方案制定。',
          achievements: [
            '国家科技进步奖获得者',
            '中华医学会健康管理学分会委员',
            '量子健康检测技术标准制定专家组成员',
            '健康管理师职业资格认证专家'
          ]
        },
        {
          id: 2,
          name: '李晓芳',
          avatar: '👩‍⚕️',
          title: '营养学专家',
          specialty: '临床营养、功能性营养干预',
          bio: '营养学博士，专注于功能性营养和精准营养研究。在肥胖管理、糖尿病营养干预、抗衰老营养等领域有丰富经验。为数千名客户制定个性化营养方案。',
          achievements: [
            '中国营养学会理事',
            '功能性食品研发专家',
            '国际营养师联盟认证专家',
            '营养学教材编委'
          ]
        },
        {
          id: 3,
          name: '王建国',
          avatar: '👨‍⚕️',
          title: '运动康复专家',
          specialty: '运动医学、康复治疗',
          bio: '运动医学硕士，前国家队队医。在运动损伤预防、康复治疗、运动处方制定等方面有丰富经验。擅长结合现代康复技术为客户提供科学的运动指导。',
          achievements: [
            '奥运会医疗保障专家',
            '中国康复医学会会员',
            '运动处方师认证导师',
            '康复治疗技术标准制定专家'
          ]
        }
      ],
      teamCategories: [
        { id: 'medical', name: '医学专家' },
        { id: 'nutrition', name: '营养专家' },
        { id: 'psychology', name: '心理专家' },
        { id: 'rehabilitation', name: '康复专家' }
      ],
      teamMembers: [
        // 医学专家
        { id: 1, category: 'medical', name: '赵医生', avatar: '👨‍⚕️', title: '内科主任医师', specialty: '心血管疾病' },
        { id: 2, category: 'medical', name: '钱医生', avatar: '👩‍⚕️', title: '内分泌专家', specialty: '糖尿病管理' },
        { id: 3, category: 'medical', name: '孙医生', avatar: '👨‍⚕️', title: '神经科专家', specialty: '神经系统疾病' },
        // 营养专家
        { id: 4, category: 'nutrition', name: '周营养师', avatar: '👩‍⚕️', title: '高级营养师', specialty: '体重管理' },
        { id: 5, category: 'nutrition', name: '吴营养师', avatar: '👨‍⚕️', title: '运动营养师', specialty: '运动营养' },
        { id: 6, category: 'nutrition', name: '郑营养师', avatar: '👩‍⚕️', title: '儿科营养师', specialty: '儿童营养' },
        // 心理专家
        { id: 7, category: 'psychology', name: '王心理师', avatar: '👨‍⚕️', title: '心理咨询师', specialty: '压力管理' },
        { id: 8, category: 'psychology', name: '李心理师', avatar: '👩‍⚕️', title: '临床心理师', specialty: '情绪调节' },
        { id: 9, category: 'psychology', name: '张心理师', avatar: '👨‍⚕️', title: '家庭治疗师', specialty: '家庭关系' },
        // 康复专家
        { id: 10, category: 'rehabilitation', name: '陈康复师', avatar: '👨‍⚕️', title: '物理治疗师', specialty: '运动康复' },
        { id: 11, category: 'rehabilitation', name: '刘康复师', avatar: '👩‍⚕️', title: '作业治疗师', specialty: '功能恢复' },
        { id: 12, category: 'rehabilitation', name: '黄康复师', avatar: '👨‍⚕️', title: '言语治疗师', specialty: '言语康复' }
      ],
      testimonials: [
        {
          id: 1,
          content: '专家团队非常专业，通过量子检测发现了我潜在的健康问题，及时进行了干预，现在身体状况明显改善。',
          name: '张先生',
          title: '企业高管',
          avatar: '👨‍💼'
        },
        {
          id: 2,
          content: '营养师为我制定的个性化营养方案很有效，三个月体重减了10公斤，各项指标都恢复正常了。',
          name: '李女士',
          title: '全职妈妈',
          avatar: '👩‍🦰'
        },
        {
          id: 3,
          content: '运动康复专家帮助我从运动损伤中恢复，现在不仅能正常运动，成绩还有所提升。',
          name: '王先生',
          title: '运动爱好者',
          avatar: '🏃‍♂️'
        }
      ],
      phone: '',
      login: false
    }
  },
  computed: {
    filteredTeamMembers() {
      return this.teamMembers.filter(member => member.category === this.activeCategory)
    }
  },
  methods: {
    viewExpertDetail(expert) {
      // 跳转到专家详情页面
      this.$router.push({
        path: '/expert-profile',
        query: { id: expert.id }
      })
    },
    submitBooking() {
      // 处理预约提交
      console.log('提交预约:', this.bookingForm)
      // 这里可以实现预约提交逻辑
      alert('预约提交成功！我们会尽快与您联系。')
      // 重置表单
      this.bookingForm = {
        name: '',
        phone: '',
        type: '',
        datetime: ''
      }
    },
    handleFeedBack() {
      this.$message.info('结果反馈功能')
    },
    handleReservationConditioning() {
      this.$message.info('查看预约功能')
    },
    reservationPromptClick() {
      this.$message.info('预约状态查询功能')
    },
    showPdf() {
      this.$message.info('检测结果功能')
    }
  }
}
</script>

<style lang="scss" scoped>
.expert-team-detail {
  padding-top: 80px; /* 为fixed导航栏留出空间 */
}

/* 导航栏样式 */
.navbar {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  transition: all 0.3s ease;
  padding: 0 20px;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  width: 100%;
}

.logo {
  width: 414.34px;
  display: flex;
  align-items: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.logo img {
  height: 40px;
  margin-right: 8px;
}



.nav-links {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 0.5rem 1rem;
  align-items: center;
  
  a, .nav-link {
    color: #2c3e50;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;
    padding: 0.5rem 0;
    position: relative;
    white-space: nowrap;
    font-size: 0.95rem;
    cursor: pointer;
    
    &:hover,
    &.active,
    &.router-link-exact-active {
      color: #3498db;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 2px;
      background-color: #3498db;
      transition: width 0.3s ease;
    }
    
    &:hover::after,
    &.active::after {
      width: 100%;
    }
    
    &.btn-accent {
      background-color: #3498db;
      color: white;
      padding: 0.6rem 1.8rem;
      border-radius: 25px;
      font-weight: 600;
      box-shadow: 0 2px 8px rgba(52, 152, 219, 0.3);
      
      &:hover {
        background-color: #2980b9;
        color: white;
        box-shadow: 0 4px 12px rgba(41, 128, 185, 0.4);
        transform: translateY(-1px);
      }
      
      &::after {
        display: none;
      }
    }
  }
}

.user-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin-left: auto;
}

.user-actions .login-btn {
  margin-left: auto;
}

.nav-btn {
  background: none;
  border: none;
  color: #2c3e50;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.3s ease;
  
  &:hover {
    color: #3498db;
  }
}

.login-btn {
  background-color: #3498db;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  
  &:hover {
    background-color: #2980b9;
    color: white;
  }
}

/* 页面标题 */
.page-header {
  background: linear-gradient(135deg, #1890FF 0%, #40a9ff 100%);
  color: white;
  text-align: center;
  padding: 4rem 2rem;
}

.page-header h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.page-header p {
  font-size: 1.2rem;
  opacity: 0.9;
}

/* 通用容器样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-title {
  text-align: center;
  font-size: 2rem;
  margin-bottom: 3rem;
  color: #333;
}

/* 团队概述 */
.team-overview {
  padding: 4rem 0;
  background: #f8f9fa;
}

.overview-content {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 4rem;
  align-items: center;
}

.overview-text h2 {
  font-size: 1.8rem;
  color: #1890FF;
  margin-bottom: 1.5rem;
}

.overview-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  color: #555;
}

.overview-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.stat-item {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 3px 15px rgba(0,0,0,0.1);
}

.stat-number {
  font-size: 2rem;
  font-weight: bold;
  color: #1890FF;
  margin-bottom: 0.5rem;
}

.stat-label {
  color: #666;
  font-size: 0.9rem;
}

/* 核心专家 */
.core-experts {
  padding: 4rem 0;
}

.experts-grid {
  display: grid;
  gap: 3rem;
}

.expert-card {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 3rem;
  background: white;
  padding: 3rem;
  border-radius: 15px;
  box-shadow: 0 5px 25px rgba(0,0,0,0.1);
  align-items: start;
}

.expert-image {
  text-align: center;
}

.expert-avatar {
  font-size: 6rem;
  margin-bottom: 1rem;
}

.expert-info h3 {
  font-size: 1.8rem;
  color: #1890FF;
  margin-bottom: 0.5rem;
}

.expert-title {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.expert-specialty {
  color: #1890FF;
  font-weight: 500;
  margin-bottom: 1.5rem;
}

.expert-bio {
  margin-bottom: 2rem;
}

.expert-bio p {
  line-height: 1.8;
  color: #555;
}

.expert-achievements h4 {
  color: #333;
  margin-bottom: 1rem;
}

.expert-achievements ul {
  list-style: none;
  padding: 0;
}

.expert-achievements li {
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
  color: #555;
}

.expert-achievements li:before {
  content: "🏆";
  margin-right: 0.5rem;
}

.btn-detail {
  background: #1890FF;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-detail:hover {
  background: #40a9ff;
  transform: translateY(-2px);
}

/* 专业团队 */
.professional-team {
  padding: 4rem 0;
  background: #f8f9fa;
}

.category-tabs {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 3rem;
}

.tab-btn {
  background: white;
  border: 2px solid #1890FF;
  color: #1890FF;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s;
}

.tab-btn.active,
.tab-btn:hover {
  background: #1890FF;
  color: white;
}

.team-members {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.team-member {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 3px 15px rgba(0,0,0,0.1);
  transition: transform 0.3s;
}

.team-member:hover {
  transform: translateY(-5px);
}

.member-avatar {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.team-member h4 {
  color: #1890FF;
  margin-bottom: 0.5rem;
}

.member-title {
  color: #666;
  margin-bottom: 0.5rem;
}

.member-specialty {
  color: #1890FF;
  font-size: 0.9rem;
}

/* 团队优势 */
.team-advantages {
  padding: 4rem 0;
}

.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.advantage-card {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 3px 15px rgba(0,0,0,0.1);
  text-align: center;
}

.advantage-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.advantage-card h3 {
  color: #1890FF;
  margin-bottom: 1rem;
}

.advantage-card p {
  color: #666;
  line-height: 1.6;
}

/* 服务流程 */
.service-process {
  padding: 4rem 0;
  background: #f8f9fa;
}

.process-flow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.process-step {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 3px 15px rgba(0,0,0,0.1);
  flex: 1;
  min-width: 150px;
}

.step-icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.process-step h3 {
  color: #1890FF;
  margin-bottom: 0.5rem;
}

.process-step p {
  color: #666;
  font-size: 0.9rem;
}

.process-arrow {
  font-size: 2rem;
  color: #1890FF;
  font-weight: bold;
}

/* 客户评价 */
.testimonials {
  padding: 4rem 0;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.testimonial-card {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 3px 15px rgba(0,0,0,0.1);
}

.testimonial-content {
  margin-bottom: 1.5rem;
}

.testimonial-content p {
  font-style: italic;
  color: #555;
  line-height: 1.6;
}

.testimonial-author {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.author-avatar {
  font-size: 2rem;
}

.author-info h4 {
  color: #1890FF;
  margin-bottom: 0.2rem;
}

.author-info p {
  color: #666;
  font-size: 0.9rem;
}

/* 预约咨询 */
.consultation-booking {
  background: linear-gradient(135deg, #1890FF 0%, #40a9ff 100%);
  color: white;
  padding: 4rem 0;
}

.booking-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: start;
}

.booking-text h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.booking-text p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.booking-benefits {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
}

.benefit {
  padding: 0.5rem 0;
}

.booking-form {
  background: rgba(255,255,255,0.1);
  padding: 2rem;
  border-radius: 10px;
  backdrop-filter: blur(10px);
}

.booking-form h3 {
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 8px;
  background: rgba(255,255,255,0.95);
  color: #333;
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #1890FF;
  background: white;
  box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
  line-height: 1.5;
}

.btn-submit {
  width: 100%;
  background: white;
  color: #1890FF;
  border: none;
  padding: 1rem;
  border-radius: 25px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

/* 底部 */
.footer {
  background-color: #263238;
  color: white;
  padding: 3rem 0 1rem;
  
  .footer-content {
    display: grid;
    grid-template-columns: 0.4fr 0.6fr;
    gap: 3rem;
    margin-bottom: 2rem;
  }
  
  .footer-links-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
  
  .footer-info h3 {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    color: #fff;
  }
  
  .footer-info p {
    margin-bottom: 0.8rem;
    color: rgba(255, 255, 255, 0.8);
  }
  
  .contact-info {
    margin-top: 1rem;
  }
  
  .contact-info p {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
  }
  
  .footer-links, .footer-services, .footer-social {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  
  .footer-links h4, .footer-services h4, .footer-social h4 {
    font-size: 1.2rem;
    margin-bottom: 0.5rem;
    color: #fff;
    position: relative;
    padding-bottom: 8px;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 40px;
      height: 2px;
      background-color: #3498db;
    }
  }
  
  .footer-links a, .footer-services a, .footer-social a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    
    &:hover {
      color: #3498db;
      padding-left: 5px;
    }
  }
  
  .social-icons {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
  
  .social-icon {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 1rem;
    text-align: center;
  }
  
  .copyright {
    opacity: 0.8;
  }
  
  .copyright p {
    margin: 0;
    font-size: 12px;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar .container {
    flex-direction: column;
    gap: 1rem;
  }

  .nav-links {
    display: none;
  }

  .page-header h1 {
    font-size: 2rem;
  }

  .overview-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .expert-card {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .booking-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .process-flow {
    flex-direction: column;
  }

  .process-arrow {
    transform: rotate(90deg);
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .footer-links-group {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>